










































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import {
    VehicleCaptureViewModel,
    VehicleCapturedSearchModel,
    RegistrationJson,
    LocationJson,
    VehicleAttachmentViewModel,
} from '@/models/inventory/vehicle.inventory';
import * as VueGoogleMap from 'vue2-google-maps';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { Utils } from '@/helper/utils';
import { ReviveNote } from '@/models/inventory/vehiclerevivestep';
import * as marked from 'marked';
import {getAttachmentHeaders, getHeaders, getTimelineHeaders} from '@/views/checkVehicleLocation/checkVehicleLocation';
import {vehicleInventoryService, vehicleReconStepService} from '@/shared';

Vue.use(VueGoogleMap, {
    load: {
        key: 'AIzaSyCKmRtPEsEE3mfqg09JZ_ueBhL8SqdUsbQ',
        libraries: 'places', // This is required if you use the Autocomplete plugin
    },
});
@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})

export default class CheckVehicleLocationSearch extends Base {
    public timelineHeaders: VHeaders[] = getTimelineHeaders(this);
    public headers: VHeaders[] = getHeaders(this);
    public attachmentHeaders: VHeaders[] = getAttachmentHeaders(this);
    public loading: boolean = false;
    public activeText: string = '';
    public selectedLocation: LocationJson = {
        createdAt: null,
        createdBy: '',
        createdByEmail: '',
        id: 0,
        latitude: '',
        longitude: '',
    };
    public searchKey: string = '';
    public capturedVehicles: VehicleCapturedSearchModel[] = [];

    public actions: any[] = [
        {
            type: 'button',
            icon: 'fas fa-map-marker',
            title: this.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.gridAction.location') as string,
            disable: (model: VehicleCapturedSearchModel) => {
                if (model.locationJson && model.locationJson.length) {
                    return false;
                }
                return true;
            },
            action: (model: VehicleCapturedSearchModel) => {
                this.openMapDialog(model);
            },
        }
        , {
            type: 'button',
            icon: 'fas fa-paperclip',
            title: this.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.gridAction.attachments') as string,
            action: (model: VehicleCapturedSearchModel) => {
                this.openAttachmentDialog(model);
            },
        }
        , {
            type: 'anchor',
            icon: 'fas fa-car',
            title: this.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.gridAction.vehicleHistory') as string,
            action: (model: VehicleCapturedSearchModel) => {
                // tslint:disable : max-line-length
                return `http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DEY_0&vin=${model.registrationJson.vin}`;
            },
        }
        , {
            type: 'button',
            icon: 'fas fa-clipboard-list',
            title: this.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.gridAction.notes') as string,
            action: (model: VehicleCapturedSearchModel) => {
                // tslint:disable : max-line-length
                this.viewNote(model);
            },
        },
        {
            type: 'button',
            icon: 'fas fa-history',
            title: this.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.gridAction.timeline') as string,
            loading: false,
            action: (model: VehicleCapturedSearchModel, action: any) => {
                this.vehicleTimelines = [];
                this.getVehicleTimeline(model, action);
            },
        }];
    public pagination = new PaginationModel('rfidTag', true);
    public openMap: IDialogOption = {
        width: '100%',
        model: false,
    };
    public isOpenMapInfoWindow: boolean = true;

    public attachmentLoading: boolean = false;
    public attachmentActions: any[] = [
        {
            type: 'button',
            icon: 'fas fa-eye',
            title: this.$parent.$t('searchVehicleLocation.attachmentGridHeaders.gridAction.viewAttachment') as string,
            action: (model: VehicleAttachmentViewModel) => {
                this.viewAttachment(model);
            },
        },
    ];

    public attachmentPagination = new PaginationModel('vin', true);
    public attachmentDialog: IDialogOption = {
        title: this.$parent.$t('searchVehicleLocation.attachmentDialog.title') as string,
        width: 1200,
        model: false,
    };
    public vehicleAttachments: VehicleAttachmentViewModel[] = [];
    public attachmentEmail: string = '';

    public noteDialog: boolean = false;
    public notesActions: any[] = [];
    public notes: ReviveNote[] = [];
    public notesPagination = new PaginationModel('name', false, 5);
    public notesHeaders: VHeaders[] = [
        {
            text: this.$parent.$t('searchVehicleLocation.noteGridHeaders.note') as string,
            align: 'left',
            sortable: false,
            value: 'noteText',
            fieldType: 'html',
            filters: [
                (item) => {
                    const htmlData = marked(item);
                    return htmlData.length > 100 ? htmlData.substring(0, 100) + '..' : htmlData;
                },
            ],
            class: 'w-100 text-truncate',
        },
        {
            align: 'center',
            isNotDataProp: true,
            text: this.$parent.$t('searchVehicleLocation.noteGridHeaders.action') as string,
            sortable: false,
        },
    ];
    public notesLoading: boolean = false;
    public noteTextToDisplay: string = '';
    public NoteDialog: IDialogOption = {
        width: 800,
        title: this.$parent.$t('searchVehicleLocation.noteDialog.title') as string,
        model: false,
    };

    public timelineDialog: IDialogOption = {
        width: '50%',
        model: false,
    };
    public timelinePagination = new PaginationModel('entryTime', false, 10);
    public timelineLoading: boolean = false;
    public vehicleTimelines: any[] = [];
    public vehicleTitle: string = '';
    public sendMailLoading: boolean = false;

    public setActions() {
        this.notesActions = [
            {
                type: 'button',
                icon: 'fas fa-eye',
                title: this.$parent.$t('searchVehicleLocation.noteGridHeaders.gridAction.view') as string,
                color: 'primary',
                action: (val) => {
                    this.showNote(val.noteText);
                },
            },
        ];
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'search') {
            this.searchVehicleCaptured();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        // let buttons: any = [];
        // buttons.push({'id':'0', 'type':'button', 'title':'Search', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Search', 'click':'search', 'icon':'fas fa-search'});
        // this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setActions();
    }

    public async searchVehicleCaptured(): Promise<void> {
        if (!this.searchKey) {
            this.showAlert(false, this.$t('searchVehicleLocation.alertEnterVinOrStockNumber'));
            return;
        }
        if (this.searchKey.length > 30) {
            this.showAlert(false, this.$t('searchVehicleLocation.alertVinOrStockNotGreaterThan30'));
            return;
        }

        try {
            this.loading = true;
            this.$emit('update:progress', this.loading);
            const response = await vehicleInventoryService.searchVehicleCaptured(this.searchKey);
            this.capturedVehicles = response;
            this.pagination.totalItems = response.length;
        } finally {
            this.loading = false;
            this.$emit('update:progress', this.loading);
        }
    }
    public viewNote(props: VehicleCapturedSearchModel): void {
        this.getVehicleNotes(props);
        this.noteDialog = true;
    }
    public closeNote(): void {
        this.noteDialog = false;
        this.notes = [];
        this.notesPagination.page = 1;
    }
    public async getVehicleNotes(model): Promise<void> {
        try {
            this.notesLoading = true;
            const response = await vehicleInventoryService.getVehicleNotes(model.stockNumber, model.tenantId, model.enterpriseId, model.storeId);
            if (response.results) {
                this.notes = response.results;
                this.notesPagination.totalItems = this.notes.length || 0;
            }
        } finally {
            this.notesLoading = false;
        }
    }

    public showNote(item: any): void {
        this.noteTextToDisplay = marked(item);
        this.NoteDialog.model = true;
    }
    public notesUpdatePaging(paging: any): void {
        this.notesPagination = paging;
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public openMapDialog(vehicleCaptured: VehicleCapturedSearchModel): void {
        this.openMap.model = true;
        this.selectedLocation = vehicleCaptured.locationJson.sort().reverse()[0];
        this.activeText = `${vehicleCaptured.rfidTag} ${this.$moment(this.selectedLocation.createdAt).format('LLL')}`;
        this.isOpenMapInfoWindow = true;
    }

    public async getVehicleAttachment(vin: string): Promise<void> {
        try {
            this.attachmentLoading = true;
            const response = await vehicleInventoryService.getCheckVehicleAttachments(vin);
            this.vehicleAttachments = response.results;
            this.attachmentPagination.totalItems = response.results.length;
        } finally {
            this.attachmentLoading = false;
        }
    }
    public openAttachmentDialog(vehicleCaptured: VehicleCapturedSearchModel): void {
        this.attachmentDialog.model = true;
        this.getVehicleAttachment(vehicleCaptured.registrationJson.vin);
    }
    public attachmentUpdatePaging(paging: any): void {
        this.attachmentPagination = paging;
    }
    public async viewAttachment(model: VehicleAttachmentViewModel): Promise<void> {
        await vehicleInventoryService.viewCheckVehicleAttachment(model.id, model.vin);
    }
    public async sendMailAttachment(): Promise<void> {
        if (!this.attachmentEmail) {
            this.showAlert(false, this.$t('searchVehicleLocation.alertEnterEmail'));
            return;
        }
        if (!Utils.EmailRegex.test(this.attachmentEmail)) {
            this.showAlert(false, this.$t('searchVehicleLocation.alertEnterValidEmail'));
            return;
        }

        const selectedAttachments = this.vehicleAttachments.filter((attachment) => {
            return attachment.id && attachment.selected === true;
        }).map((m) => m.id.toString());
        if (!selectedAttachments || !selectedAttachments.length) {
            this.showAlert(false, this.$t('searchVehicleLocation.alertSelectAtLeastOneAttachment'));
            return;
        }
        const attachmentIds = selectedAttachments.join();
        try {
            this.sendMailLoading = true;
            await vehicleInventoryService.checkVehicleLocationSendMail(attachmentIds, this.attachmentEmail);
            this.showAlert(true, this.$t('searchVehicleLocation.alertSelectAtLeastOneAttachment'));
        } finally {
            this.sendMailLoading = false;
            this.attachmentEmail = '';
            this.attachmentDialog.model = false;
        }
    }

    public async getVehicleTimeline(model: VehicleCapturedSearchModel, action: any): Promise<void> {
        try {
            this.timelineLoading = true;
            this.timelineDialog.model = true;
            const response = await vehicleReconStepService.getVehicleTimelineAnonymous(
                model.stockNumber, model.vin);

            this.vehicleTimelines = response.results;
            this.pagination.totalItems = response.total;
            if (this.vehicleTimelines.length) {
                this.vehicleTitle = this.vehicleTimelines[0].make + ' ' + this.vehicleTimelines[0].model;
            }
        } finally {
            this.timelineLoading = false;
        }
    }
    public updateTimelinePaging(paging: any) {
        this.timelinePagination = paging;
    }
}
